import { TextField } from "@Components/generic";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import useI18n from "@i18n";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme } from "@mui/material";
import { ChangeEvent, useState } from "react";

interface IConfirmDialog {
  open: boolean;
  toggle?: () => void;
  confirm: (input: string) => void;
  cancel: () => void;
  title: string;
  message: string;
  icon: any;
  textInput?: boolean;
  inputLabel?: string;
  inputType?: string;
  confirmText?: string;
  cancelText?: string;
  box?: boolean;
}

const ConfirmDialog = ({
  open,
  toggle = () => { },
  confirm,
  cancel = () => { },
  title,
  message,
  icon,
  textInput = false,
  inputLabel = "",
  inputType = "text",
  confirmText,
  cancelText,
  box = true
}: IConfirmDialog) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const [inputValue, setInputValue] = useState<string>("");

  const handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  return (
    <>
    <Box
          sx={{
            height: box ? "100%" : "0px",
            width: box ? "100%" : "0px",
            position: "absolute",
            zIndex: "100",
          }}>
          <Dialog open={open} onClose={toggle}>
            <DialogTitle id="alert-dialog-title" color="dsBase.v200">
              {icon ? (
                <Icon
                  icon={icon}
                  style={{
                    marginRight: theme.spacing(1),
                  }}
                />
              ) : null}
              {title}
            </DialogTitle>
            <DialogContent
              sx={{
                minWidth: "300px",
                maxWidth: "430px",
              }}
            >
              <Typography variant={"body1"} color="dsBase.v200">{message}</Typography>
            </DialogContent>
            {textInput ? (
              <form
                autoComplete="off"
                style={{
                  marginLeft: theme.spacing(4),
                  marginRight: theme.spacing(4),
                  marginBottom: theme.spacing(4),
                }}
              >
                <TextField
                  autoFocus
                  margin="dense"
                  id="input-1"
                  label={inputLabel || ""}
                  type={inputType || "text"}
                  autoComplete="off"
                  fullWidth
                  onChange={handleTextChange}
                />
              </form>
            ) : null}
            <DialogActions>
              <Button onClick={cancel} color="primary" autoFocus>
                {cancelText || i18n("button.cancel")}
              </Button>
              <Button
                onClick={() => {
                  confirm(inputValue);
                }}
                color="primary"
                variant="contained"
                autoFocus
              >
                {confirmText || i18n("button.confirm")}
              </Button>
            </DialogActions>
          </Dialog>
          </Box>
      </>
  );
};

export default ConfirmDialog;
